export interface CallUsBannerProps {
  title?: string;
  subtext?: string;
}

export const CallUsBanner: React.FunctionComponent<CallUsBannerProps> = (
  props: CallUsBannerProps,
) => {
  const title = props.title || 'Call us now to make the report';
  const subtext =
    props.subtext || 'Call us so your report can be assessed and submitted.';
  return (
    <section className="bg-status-error section-vertical-padding section-horizontal-padding -section-horizontal-margin flex flex-col gap-y-7 py-8 text-white">
      <section className="text-h1">{title}</section>
      <section className="flex flex-col gap-y-3">
        <div className="text-bodyLg">{subtext}</div>
      </section>
    </section>
  );
};
